import {
  allRequest,
  deleteRequest,
  putRequest,
  REQUEST_METHOD_GET
} from "../../../../middlewares/api/actions";
import {
  getAllCubeUrl,
  getCubeUrl,
  getDcsUrl,
  getDeleteDCSCategoryUrl,
  getEditDCSCategoryUrl
} from "../../../../constants/urls";

export const BUILDER_CUBE_TREE_CATEGORISED_CUBES_READ = 'BUILDER_CUBE_TREE_CATEGORISED_CUBES_READ';
export const BUILDER_CUBE_TREE_CUBE_SELECT = 'BUILDER_CUBE_TREE_CUBE_SELECT';
export const BUILDER_CUBE_TREE_CUBE_CATEGORY_SELECT = 'BUILDER_CUBE_TREE_CUBE_CATEGORY_SELECT';
export const BUILDER_CUBE_TREE_CUBE_CREATE = 'BUILDER_CUBE_TREE_CUBE_CREATE';
export const BUILDER_CUBE_TREE_CUBE_DELETE = 'BUILDER_CUBE_TREE_CUBE_DELETE';
export const BUILDER_CUBE_TREE_CATEGORY_DELETE = 'BUILDER_CUBE_TREE_CATEGORY_DELETE';
export const BUILDER_CUBE_TREE_CATEGORY_MOVE = 'BUILDER_CUBE_TREE_CATEGORY_MOVE';

export const readBuilderCubeTreeCategorisedCubes = (forbiddenCubes, forbiddenCategories) => ({
  ...allRequest(
    BUILDER_CUBE_TREE_CATEGORISED_CUBES_READ,
    [REQUEST_METHOD_GET, REQUEST_METHOD_GET],
    [getAllCubeUrl(), getDcsUrl()]
  ),
  forbiddenCubes,
  forbiddenCategories
});

export const deleteBuilderCubeTreeCube = cubeId =>
  deleteRequest(
    BUILDER_CUBE_TREE_CUBE_DELETE,
    getCubeUrl(cubeId),
    t => ({
      success: t('scenes.dataManager.builder.cubeTree.messages.cubeDelete.success')
    })
  );

export const selectBuilderCubeTreeCube = cubeId => ({
  type: BUILDER_CUBE_TREE_CUBE_SELECT,
  cubeId
});

export const selectBuilderCubeTreeCubeCategory = category => ({
  type: BUILDER_CUBE_TREE_CUBE_CATEGORY_SELECT,
  category
});

export const createBuilderCubeTreeCube = cubeCategoryId => ({
  type: BUILDER_CUBE_TREE_CUBE_CREATE,
  cubeCategoryId,
});

export const deleteBuilderCubeTreeCategory = catCode => deleteRequest(
  BUILDER_CUBE_TREE_CATEGORY_DELETE,
  getDeleteDCSCategoryUrl(catCode),
  t => ({
    success: t('scenes.dataManager.builder.cubeTree.messages.categoryDelete.success')
  })
);

export const moveBuilderCubeTreeCategory = categories => putRequest(
  BUILDER_CUBE_TREE_CATEGORY_MOVE,
  getEditDCSCategoryUrl(),
  categories.map(cat => ({
    parCode: cat.ParCode,
    catCode: cat.CatCode,
    idCat: cat.IDCat,
    ord: cat.Ord,
    labels: cat.labels
  })),
  t => ({
    success: t('scenes.dataManager.builder.cubeTree.messages.categoryMove.success')
  })
);